import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  mfaBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#fff',
    borderRadius: '12px',
    width: '90%',
    maxWidth: '800px',
    boxSizing: 'border-box',
    padding: '40px',
    margin: '40px auto',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: '24px',
      margin: '20px auto',
      borderRadius: '12px 12px 0 0'
    }
  },
  backButton: {
    alignSelf: 'flex-start',
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  codeInputsContainer: {
    display: 'flex',
    gap: '12px',
    marginBottom: '16px',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      gap: '8px'
    }
  },
  codeInput: {
    width: '50px',
    height: '50px',
    border: '2px solid #E8F5E8',
    borderRadius: '8px',
    textAlign: 'center',
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    background: '#fff',
    outline: 'none',
    transition: 'all 0.3s ease',
    '&:focus': {
      borderColor: theme.palette.secondary.main,
      boxShadow: '0 0 0 3px rgba(108, 183, 175, 0.1)'
    },
    [theme.breakpoints.down('sm')]: {
      width: '40px',
      height: '50px',
      fontSize: '20px'
    },
    [theme.breakpoints.up('md')]: {
      width: '60px',
      height: '70px',
      fontSize: '28px'
    }
  },
  resendLink: {
    color: theme.palette.secondary.main,
    fontSize: '16px',
    fontWeight: 500,
    cursor: 'pointer',
    textDecoration: 'underline',
    marginBottom: '8px',
    textAlign: 'center',
    '&.disabled': {
      color: '#ccc',
      cursor: 'not-allowed',
      textDecoration: 'none'
    }
  },
  countdown: {
    fontSize: '12px',
    color: '#999',
    textAlign: 'center',
    marginBottom: '24px'
  },
  countdownHighlight: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold'
  }
}))
